import { useEffect, useState } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { fetchGameLabels } from "../../../functions/favouriteGameLabel";
import { extractGames } from "../../../functions/gameExtraction";
import { getLabelFilter, toggleLabel } from "../../../functions/labelUtils";
import GameLabelDisplayer from "../game/gamelabel/view/GameLabelDisplayer";
import PageLayout from "../../PageLayout";

function GameRandomizer({ token, onError, onSearchProductClicked }) {
    const { t } = useTranslation('messages');

    const [labels, setLabels] = useState([]);
    const [checkedLabels, setCheckedLabels] = useState(new Map());
    const [numGamesToExtract, setNumGamesToExtract] = useState(1);
    const [extractedGames, setExtractedGames] = useState([]);

    useEffect(() => {
        fetchGameLabels(token, (data) => setLabels(data.labels), onError);
    }, [token, onError]);

    return (
        <PageLayout
            hero={
                <>
                    <h1 className="display-5 fw-bold mb-4">{t('private_area.random_games_tab.labels_title')}</h1>
                    <div className="mb-3">
                        <GameLabelDisplayer
                            button_id_prefix="GameRandomizer"
                            gameLabels={labels}
                            checkedLabels={checkedLabels}
                            checkLabel={(labelId) => setCheckedLabels(toggleLabel(labelId, checkedLabels))}
                        />
                    </div>
                    <Row>
                        <Col xs={12} md={4}>
                            <Form onSubmit={(e) => {
                                e.preventDefault();
                                drawGames(token, checkedLabels, numGamesToExtract, setExtractedGames, onError);
                            }}>
                                <InputGroup size="lg">
                                    <Form.Control
                                        type="number"
                                        min={1}
                                        placeholder={t('private_area.random_games_tab.number_of_games_placeholder')}
                                        value={numGamesToExtract}
                                        onChange={(e) => setNumGamesToExtract(parseInt(e.target.value))}
                                        className="border-0"
                                    />
                                    <Button variant="light" type="submit" className="fw-semibold px-4">
                                        {t('private_area.random_games_tab.draw_games_button_text')}
                                    </Button>
                                </InputGroup>
                            </Form>
                        </Col>
                    </Row>
                </>
            }
        >
            {extractedGames.length > 0 && (
                <>
                    <h2 className="fw-bold mb-3">{t('private_area.random_games_tab.result_title')}</h2>
                    <div>
                        {extractedGames.map((game) => (
                            <div key={game.link} className="card border-0 shadow-sm mb-3">
                                <div className="card-body p-3 d-flex gap-3 align-items-start">
                                    {game.image_link && (
                                        <img
                                            src={game.image_link}
                                            alt={game.name}
                                            className="rounded flex-shrink-0"
                                            style={{ width: 72, height: 72, objectFit: 'cover' }}
                                        />
                                    )}
                                    <div className="flex-grow-1 min-w-0">
                                        <a href={game.link} target="_blank" rel="noreferrer"
                                            className="fw-semibold text-dark text-decoration-none">
                                            {game.name}
                                        </a>
                                        {game.description && (
                                            <p className="text-clamp text-muted small mb-2 mt-1">
                                                {game.description}
                                            </p>
                                        )}
                                        <Button size="sm" variant="outline-secondary" className="mt-1"
                                            onClick={() => onSearchProductClicked(game.name)}>
                                            {t('private_area.random_games_tab.result_search_button_text')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </PageLayout>
    );
}

function drawGames(token, checkedLabels, numGamesToExtract, setExtractedGames, onError) {
    const { includedGameLabelIds, excludedGameLabelIds } = getLabelFilter(checkedLabels);
    extractGames(token, (data) => setExtractedGames(data.games), onError, includedGameLabelIds, excludedGameLabelIds, numGamesToExtract);
}

export default GameRandomizer;
